import { FigmaTypography } from "@libs/zapi-ui/custom";
import { TClaimEvidence } from "../model/types";
import { cn } from "@/zapi-frontend/shared/lib/utils";
import { CheckCircle2Icon } from "lucide-react";
import { Source } from "./_Source";
import { EvidenceStatusBadge } from "./_EvidenceStatusBadge";

type TProps = {
  evidence: TClaimEvidence;
};

export function EvidenceItem({ evidence }: TProps) {
  const isSelected = evidence.sourceMatchesMemo;

  return (
    <div
      className={cn(
        "bg-white rounded-xl border border-gray-200 shadow-sm hover:shadow-lg transition-all duration-200",
        isSelected && "border-innoveraGreen-700"
      )}
    >
      <div className="p-4 flex flex-col gap-3">
        <div className="flex items-center gap-3 justify-between">
          <FigmaTypography variant="body-2" className="text-[14px] font-medium text-innoveraZinc-900">
            Source
          </FigmaTypography>

          <Source source={evidence.sourceId} />
        </div>
        <div className="h-[1px] bg-innoveraZinc-150" />
        <div className="flex items-start gap-3 justify-between">
          <FigmaTypography variant="body-2" className="text-[14px] font-medium text-innoveraZinc-900">
            Status
          </FigmaTypography>
          <EvidenceStatusBadge strength={evidence.evidenceStrength} />
        </div>
        <div className="h-[1px] bg-innoveraZinc-150" />
        <div className="flex flex-col gap-3">
          <FigmaTypography variant="body-2" className="text-[14px] font-medium text-innoveraZinc-900">
            Reasoning
          </FigmaTypography>
          <FigmaTypography variant="body-2" className="text-innoveraZinc-600 break-words min-w-0">
            {evidence.reasoning}
          </FigmaTypography>
        </div>
      </div>
      {isSelected && (
        <div className="flex items-center p-3 justify-center bg-innoveraGreen-50 rounded-b-xl gap-1">
          <CheckCircle2Icon className="h-4 w-4 text-innoveraGreen-700" />
          <FigmaTypography variant="label-3" className="text-innoveraGreen-700">
            Selected Source
          </FigmaTypography>
        </div>
      )}
    </div>
  );
}
